<h1 mat-dialog-title>
  {{ 'common.attachments' | translate }}
</h1>

<div mat-dialog-content>
  <div class="row mb-4 file-box">
    <div class="col-12 d-flex align-items-center mb-4 g-0">
      <div class="me-4">
        <p *ngIf="!selectedFile; else elseBlock" class="mb-0">
          {{ 'map.sidebar.raccordo-cavo.attachment.placeholder' | translate }}
        </p>

        <ng-template #elseBlock>
          <p class="mb-0">{{ selectedFile.name }}</p>
        </ng-template>
      </div>

      <button mat-icon-button color="accent" *ngIf="selectedFile" (click)="deleteFile(fileInput)">
        <mat-icon>delete</mat-icon>
      </button>

      <button mat-button color="secondary" type="button" (click)="fileInput.click()" *ngIf="!selectedFile">
        <mat-icon>folder</mat-icon>
        <span class="ms-1"> {{ 'common.choose_file' | translate }}</span>
      </button>
    </div>
    <div class="col-12 d-flex justify-content-end g-0">
      <input
        #fileInput
        type="file"
        (change)="onFileSelected($event)"
        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
        style="display: none"
      />

      <button mat-raised-button color="primary" type="button" [disabled]="!selectedFile" (click)="uploadFile()">
        <mat-icon>cloud_upload</mat-icon>
        <span class="mx-1"> {{ 'common.upload_file' | translate }}</span>
      </button>
    </div>
  </div>

  <div class="map-table-content">
    <mtx-grid
      [data]="attachments"
      [columns]="columnGrid"
      [showColumnMenuHeader]="false"
      [showFirstLastButtons]="false"
      [rowStriped]="true"
      [pageSize]="!!attachments.length ? attachments.length : 50"
      [hidePageSize]="true"
      [showPaginator]="false"
      [noResultText]="'common.no_result' | translate"
    >
    </mtx-grid>

    <ng-template #actionsTemplate let-row>
      <div class="d-flex align-items-center">
        <button mat-icon-button (click)="download(row)">
          <mat-icon>download_for_offline</mat-icon>
        </button>
        <button mat-icon-button *ngIf="isEditable" (click)="onDeleteAttachment(row.id)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </ng-template>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false" color="secondary">{{ 'common.close' | translate }}</button>
</div>
